import {useEffect, useState} from "react";
import {Button, Fade, Paper, Popper} from "@mui/material";
import Typography from "@mui/material/Typography";
import useEventDispatcher from "../../use/useEventDispatcher";
import Box from "@mui/material/Box";
import {Check} from "@mui/icons-material";
import isNull from "../../mixin/isNull";

/**
 *
 * @param elementRef Ref of element
 * @param content Popper content
 * @param placement {string}
 * @param triggeringEvent Open on event ...
 * @param displayCloseButton
 * @param closeButtonContent
 * @param autoCloseAfter
 * @param closeOnClick
 * @param contentColor
 * @return {JSX.Element}
 */
export default function ({
                             elementRef,
                             content,
                             placement = "top",
                             triggeringEvent,
                             displayCloseButton = true,
                             closeButtonContent = "J'ai compris !",
                             autoCloseAfter = null,
                             closeOnClick = false,
                             contentColor = "warning",
                             icon = null
                         }) {
    const eventDispatcher = useEventDispatcher();
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        eventDispatcher.subscribe(triggeringEvent, handleEvent);

        return () => eventDispatcher.unsubscribe(triggeringEvent, handleEvent);
    }, []);

    const handleEvent = () => {
        setAnchorEl(elementRef.current);
        setOpen(true);

        if (!isNull(autoCloseAfter)) {
            setTimeout(() => setOpen(false), autoCloseAfter);
        }
    }

    const handleClose = () => {
        if (!closeOnClick) return;

        setOpen(false);
    }

    return (
        <>
            <Popper
                // Note: The following zIndex style is specifically for documentation purposes and may not be necessary in your application.
                sx={{zIndex: 1200}}
                open={open}
                anchorEl={anchorEl}
                placement={placement}
                transition
            >
                {({TransitionProps}) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper elevation={10} sx={{py: 1, px: 2}} onClick={handleClose}>
                            <Box display="flex" alignItems="center">
                                <Box ml={3}>
                                    {icon}
                                </Box>
                                <Typography color={contentColor} fontSize={"small"}>
                                    {content}
                                </Typography>
                            </Box>
                            {
                                displayCloseButton
                                    ? (
                                        <Box display="flex" justifyContent="end">
                                            <Button startIcon={<Check/>} color={"success"}
                                                    onClick={() => setOpen(false)}>
                                                {closeButtonContent}
                                            </Button>
                                        </Box>
                                    )
                                    : null
                            }
                        </Paper>
                    </Fade>
                )}
            </Popper>
        </>
    );

}